import { render } from "./DefLink.vue?vue&type=template&id=1b7388cc&scoped=true"
import script from "./DefLink.vue?vue&type=script&lang=js"
export * from "./DefLink.vue?vue&type=script&lang=js"

import "./DefLink.vue?vue&type=style&index=0&id=1b7388cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7388cc"]])

export default __exports__